const buttonSizeData = ['default', 'xl', 'lg', 'md', 'sm'];

export default buttonSizeData;
